const brand = sessionStorage.getItem('brand');
export const home = {
  greetingText: '你好，',
  greetingHand: '👋',
  upgrade: '升级',
  integrate: '集成',
  integrate2: '集成',
  chatGPT: 'ChatGPT ',
  forYourBusiness: '为您的业务',
  insights: '见解',
  message: '消息',
  addon: '附加功能：',
  leads: '潜在客户',
  yourBots: '您的机器人',
  botName: '机器人名称',
  platform: '平台',
  contactOrLeads: '联系人/潜在客户',
  actions: '操作',
  edit: '编辑',
  delete: '删除',
  createA: '创建一个 ',
  whatsappChatbot: 'WhatsApp 聊天机器人 ',
  connect: '连接',
  getStartedWithUs: '开始使用我们吧 👏',
  howToBuildAGoodChatFlow: ' 如何构建良好的聊天流程',
  howToUseBotPenguinInboxAndItsFeatures: ' 如何使用 BotPenguin 的收件箱及其功能',
  botPenguinPricing: ' BotPenguin 的定价：探索计划和功能',
  openHelpDesk: ' 打开帮助台',
  helpAndSupport: '帮助与支持',
  extensiveGuides: '我们的资源中心中提供了所有常见查询和工作流的',
  resourceCentre: '资源中心。',
  checkoutOurAnswers: '您可以查看以下对常见问题的回答。',
  createANewBot: '创建一个新的机器人',
  installYourBot: '安装您的机器人',
  plansAndPricing: '计划和定价',
  searchLanguage: '搜索语言',
  whatsappConversations: 'WhatsApp 对话',
  diveDeeperIntoBotPenguin: '深入了解 BotPenguin',
  knowWhereWeAreGoing: '了解我们的发展方向、最新更新并帮助我们修复一些错误。',
  productUpdates: '产品更新',
  requestAFeature: '提出功能请求',
  reportABug: '报告错误',
  productRoadmap: '产品路线图',
  contactsOrLeads: '联系人/潜在客户',
  english: '英语',
  hindi: '印地语',
  german: '德语',
  french: '法语',
  portuguese: '葡萄牙语',
  spanish: '西班牙语',
  italian: '意大利语',
  russian: '俄语',
  pleaseSelectYourReason: '请选择您的原因',
  cancel: '取消',
  submit: '提交！',
  giveFeedback: '提供反馈',
  ratings: '评分',
  reasonBehindYourDecision: '决定背后的原因',
  shareYourExperience: '分享您的经验',
  reason1: '原因1',
  reason2: '原因2',
  appTooltip: {
    HOME_INSIGHT: '提供所有机器人消息和潜在客户的见解（数据每天午夜更新）',
    HOME_MESSAGES: '您的帐户在此计费周期内消耗的消息。（WhatsApp、Facebook 和 Telegram 机器人的消息除外。）',
    HOME_TOTAL_MESSAGES: '自帐户创建以来您的帐户消耗的消息总数（WhatsApp、Facebook 和 Telegram 机器人的消息除外。）',
    LEADS: '此计费周期内为您的帐户捕获的潜在客户。',
    TOTAL_LEADS: '自帐户创建以来为您的帐户捕获的总联系人/潜在客户数（数据每天午夜更新）。',
    YOUR_BOT: '所有机器人及其在此计费周期内的使用概述。',
    NAME: '机器人的名称',
    PLATFORM: '机器人的平台',
    MESSAGES: '自帐户创建以来机器人的总消息',
    CONTACTS: '机器人的总联系人/潜在客户',
    ACTIONS: '编辑/删除机器人',
    EDIT_ICON: '编辑机器人的聊天流程和设置',
    DELETE_ICON: '删除机器人',
    TOOL_TIP_CLASSIC_VERSION: `${brand} UI 的旧版本`
  },
  modal: {
    deleteBot: '删除机器人！',
    areYouSure: '您确定要删除此机器人吗？',
    enquiryForm: '询问表格',
    payNow: '立即付款！',
    saveAndDelete: '保存并删除',
    submit: '提交',
  },
  noDataFound: {
    bots: '机器人',
    noBotCreatedYet: '尚未创建机器人！',
  },
  yourFriendWillMissYou: '您的朋友会想念您',
  rateYourBotCreationExperience: '评价您的机器人创建体验',
  whatMadeYouDeleteYourBot: '是什么让您删除机器人？',
  iCreatedByMistake: '我创建得不对',
  iWantToCreateAnotherBot: '我想创建另一个机器人',
  couldNotFindFeaturesThatINeeded: '找不到我需要的功能',
  uiWasHardToNavigate: 'UI 难以导航',
  iDonotWantToTell: '我不想告诉',
  other: '其他',
  weWillDoOurBestToMakeAutomationFun: '我们将尽力使自动化变得有趣且简单易懂。',
};
